import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/publishers/formats/InterstitialExample.png")